/* eslint-disable react/require-default-props */
/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import IconButton from '@material-ui/core/IconButton';
// import Tooltip from '@material-ui/core/Tooltip';

import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import RemoveRedEyeIcon from '@material-ui/icons/RemoveRedEye';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';

import { get } from 'lodash-es';
import { Tooltip } from '../../Components/Tooltip';
import DateCellRenderer from './DateCellRenderer';

export const columns = (handleOnClick, strings, i18n) => {
  const uid = 'id';

  const ActionsColumnCellRenderer = ({ dataKey, parent, rowData, cellData, rowIndex }) => {
    // eslint-disable-next-line no-underscore-dangle
    window.__MUI_USE_NEXT_TYPOGRAPHY_VARIANTS__ = true;

    const getIcon = action => {
      switch (action.get('action')) {
        case 'modify':
          return <EditIcon fontSize="small" />;
        case 'cancel':
          return <DeleteIcon fontSize="small" />;
        case 'view':
          return <RemoveRedEyeIcon fontSize="small" />;
        case 'link':
          return <OpenInNewIcon fontSize="small" />;

        default:
          return get(strings, action.get('label'));
      }
    };
    const getColor = action => {
      switch (action.get('action')) {
        case 'modify':
          return 'primary';
        case 'cancel':
          return 'secondary';
        case 'view':
          return 'primary';
        case 'link':
          return 'primary';

        default:
          return 'primary';
      }
    };
    const actions = [];
    try {
      const id = rowData.get(uid);
      cellData.forEach(action => {
        if (action.get('type') === 'action') {
          actions.push(
            <Tooltip title={get(strings, action.get('label'), '')} placement="left" key={`tooltip-${id}`}>
              <IconButton
                title={get(strings, action.get('label'))}
                size="small"
                key={`${action.get('route')}-${id}`}
                label={get(strings, action.get('label'))}
                aria-label={get(strings, action.get('label'))}
                color={getColor(action)}
                className={getColor(action)}
                onClick={() =>
                  handleOnClick({
                    route: action.get('route'),
                    type: action.get('type'),
                    action: action.get('action'),
                    id: { id },
                  })
                }
                onTouchEnd={() =>
                  handleOnClick({
                    route: action.get('route'),
                    type: action.get('type'),
                    action: action.get('action'),
                    id: { id },
                  })
                }
              >
                {/* {get(strings, action.get('label')]} */}
                {getIcon(action)}
              </IconButton>
            </Tooltip>
          );
        } else {
          const route = action.get('route');
          const link = props => <Link to={route} {...props} />;
          const label = get(strings, action.get('label'), '');
          actions.push(
            <Tooltip key={`tooltip-${id}`} title={label} placement="left" className="coog-tooltip">
              <IconButton
                // title={get(strings, action.get('label')]}
                component={React.forwardRef((props, ref) => link(props))}
                size="small"
                key={`${action.get('route')}-${id}`}
                label={label}
                aria-label={label}
                color={getColor(action)}
                className={getColor(action)}
              >
                {getIcon(action)}
              </IconButton>
            </Tooltip>
          );
        }
      });
    } catch (e) {
      actions.push(`Invalid link: ${e}`);
    }

    return <>{actions}</>;
  };
  ActionsColumnCellRenderer.propTypes = {
    cellData: PropTypes.any,
    rowData: PropTypes.any,
    dataKey: PropTypes.any,
    parent: PropTypes.any,
    rowIndex: PropTypes.any,
  };

  const CodeCellRenderer = ({ dataKey, parent, rowData, cellData = '', rowIndex }) => (
    <span className="cell code">{cellData}</span>
  );

  const StatusCellRenderer = ({ dataKey, parent, rowData, cellData = '', rowIndex }) => {
    let cell;
    let label;
    const status = cellData.toLowerCase();

    label = get(strings, `salesroutes.filter.status.options.${status}.label`, status);

    try {
      cell = (
        <div
          title={label}
          style={{
            alignItems: 'center',
            justifyContent: 'left',
            display: 'flex',
          }}
        >
          <div className={`status ship2 ${status}`} />
          <div className={`status label ${status}`}>{label}</div>
        </div>
      );
    } catch (e) {
      cell = `Invalid link: ${e}`;
    }

    return <>{cell}</>;
  };

  const FormatedDateCellRenderer = ({ dataKey, parent, rowData, cellData, rowIndex }) => (
    <DateCellRenderer
      dataKey={dataKey}
      parent={parent}
      rowData={rowData}
      cellData={cellData}
      rowIndex={rowIndex}
      i18n={i18n}
    />
  );

  return [
    {
      name: 'id',
      label: get(strings, 'salesroute.grid.column.code.label', 'Identifiant'),
      width: 80,
      type: 'rendered',
      render: CodeCellRenderer,
    },
    {
      name: 'questionnaireLabel',
      label: get(strings, 'salesroute.grid.column.questionnaire.label', 'Questionnaire'),
      width: 100,
    },
    {
      name: 'status',
      label: get(strings, 'salesroute.grid.column.status.label', 'Status'),
      width: 80,
      type: 'rendered',
      render: StatusCellRenderer,
    },
    {
      name: 'coveredsLabel',
      label: get(strings, 'salesroute.grid.column.covered.label', 'Assuré(s)'),
      width: 80,
      type: 'rendered',
    },
    {
      name: 'subscribersLabel',
      label: get(strings, 'salesroute.grid.column.subscriber.label', 'Souscripteur(s)'),
      width: 80,
      type: 'rendered',
    },
    {
      name: 'createdAt',
      label: get(strings, 'salesroute.grid.column.start_date.label', 'Start Date'),
      width: 100,
      type: 'rendered',
      render: FormatedDateCellRenderer,
    },
    {
      name: 'updatedAt',
      label: get(strings, 'salesroute.grid.column.update_date.label', 'Update Date'),
      width: 100,
      type: 'rendered',
      render: FormatedDateCellRenderer,
    },
    {
      name: 'actions',
      label: get(strings, 'salesroute.grid.column.actions.label', 'Actions'),
      width: 30,
      type: 'rendered',
      render: ActionsColumnCellRenderer,
    },
  ];
};

// ================
// FILTERS UI
// ================
const getQuestionnairesOptions = ({ questionnaires }) => {
  try {
    return Array.isArray(questionnaires.toJS())
      ? questionnaires.toJS().map(questionnaire => ({
          value: String(questionnaire.id),
          label: String(questionnaire.title),
        }))
      : [];
  } catch (error) {
    return [];
  }
};

export const filtersUI = ({ strings, questionnaires }) => ({
  query: {
    value: '',
    label: get(strings, 'salesroutes.filter.query.label', 'Filtrer par ID ou statut'),
    placeholder: get(strings, 'salesroutes.filter.query.placeholder', 'ex : created'),
    type: 'text',
    name: 'query',
  },
  queryName: {
    value: '',
    label: get(strings, 'salesroutes.filter.queryName.label', 'Filtrer par assuré'),
    placeholder: get(strings, 'salesroutes.filter.queryName.placeholder', 'ex : John Doe'),
    type: 'text',
    name: 'query',
  },
  questionnaire: {
    value: {
      name: undefined,
      id: undefined,
    },
    options: questionnaires ? getQuestionnairesOptions({ questionnaires }) : [],
    label: get(strings, 'salesroutes.filter.questionnaire.label', 'Filtrer par questionnaire'),
    name: 'questionnaireLabel',
    type: 'checkbox',
  },
});
